import { $, $$ } from '@utils';
import datalayerPushGeneric from '@utils/DataLayerPushGeneric';

function init() {
  if (!$('[data-au-content-table]')) return;

  addEventListeners();
}

function addEventListeners() {
  $$('[data-au-content-table-action-button]').forEach((elem) => {
    elem.addEventListener('click', (e) => {
      const titleTable = e.target.closest('[data-au-content-table]').querySelector('[data-au-content-table-title'),
        titleTableText = titleTable ? titleTable.innerText : '';

      datalayerPushGeneric(e, 'navigation', 'clickBoton', titleTableText);
    });
  });
}

export default { init };
